// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".router_link[data-v-2436f7d2]{color:inherit}", ""]);
// Exports
module.exports = exports;
